import styled from 'styled-components';
import { spacing } from '@pb/styles';
import { HorizontalLine } from '@pb/shared/ui/atoms/horizontal-line';

export const StyledContainer = styled.div`
    margin: ${spacing(8, 0)};
`;

export const StyledHorizontalLine = styled(HorizontalLine)`
    margin: ${spacing(8, 0)};
`;
